import { Link } from "@tanstack/react-router";
import { useLanguage } from "@/lib/language";

/**
 * A TanStack Link that keeps navigation inside the active language.
 * On Arabic pages it prefixes the target with /ar so users don't fall back to
 * English mid-session. Pass the ENGLISH `to` (e.g. "/services" or
 * "/services/$slug"); the prefix is applied automatically.
 */
export function LangLink({ to, ...props }: { to: string } & Record<string, unknown>) {
  const { lang } = useLanguage();
  const target = lang === "ar" ? (to === "/" ? "/ar" : `/ar${to}`) : to;
  // `to` is a runtime-computed string; cast past TanStack's literal-route typing.
  return <Link to={target as never} {...(props as Record<string, unknown>)} />;
}
